import moment from 'moment';
import { Typography } from 'antd';

import React, { FC } from 'react';
import '../style.scss';
import PageTopWrapper from './page-top-wrapper';
import { formatNumberMoney } from '@/util/formatNumberMoney';
interface IProps {
    dataReport: any;
}

const CopyContent: FC<IProps> = ({ dataReport = {} }) => {
    const sumProduct = (products: any) => {
        return products?.reduce((product: any, { total }: any) => product + total, 0) || 0;
    };

    return (
        <div className="report-content-copy">
            <PageTopWrapper leftContent={<Typography.Title level={5}>Báo cáo nhanh</Typography.Title>} />
            <div className="content-report-copy">
                <b>
                    Báo cáo doanh thu{' '}
                    {`${dataReport?.isMonth ? 'tháng' : 'ngày'} ${moment(dataReport?.date).format(
                        dataReport?.isMonth ? 'MM/YYYY' : 'DD/MM/YYYY',
                    )}`}
                </b>
                <span className="newline"></span>
                <span className="tab">&#9;&#9;&#9;</span>
                <b>- Số lần thuê phòng: {dataReport?.generateOrder?.luotcheckin} lượt</b>
                <span className="newline"></span>
                {dataReport?.listCountUsers?.map((item: any) => (
                    <div>
                        <span className="tab">&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;</span>
                        <span style={{ fontSize: '14px' }}>
                            + {item?.name}: <b>{item?.total} lượt</b>
                        </span>
                        {/* <span className="newline"></span>
                        {item?.user?.map((user: any) => (
                            <div>
                                <span className="tab">&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;</span>
                                <span style={{ fontSize: '14px' }}>
                                    ｏ {user?.name}: <b>{user?.total} lượt</b>
                                </span>
                                <span className="newline"></span>
                            </div>
                        ))} */}
                    </div>
                ))}
                <span className="tab">&#9;&#9;&#9;</span>
                <span className="newline"></span>
                {dataReport?.listCountNoteType?.map((item: any) => (
                    <div>
                        <span className="tab">&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;</span>
                        <span style={{ fontSize: '14px' }}>
                            + {item?.name}: <b>{item?.total} lượt</b>
                        </span>
                        <span className="newline"></span>
                        {/* {item?.user?.map((user: any) => (
                            <div>
                                <span className="tab">&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;</span>
                                <span style={{ fontSize: '14px' }}>
                                    ｏ {user?.name}: <b>{user?.total} lượt</b>
                                </span>
                                <span className="newline"></span>
                            </div>
                        ))} */}
                    </div>
                ))}
                <span className="tab">&#9;&#9;&#9;</span>
                <b>- Sản phẩm đã bán: {sumProduct(dataReport?.listCountProduct || [])}</b>
                <span className="newline"></span>
                {dataReport?.listCountProduct?.map((item: any) => (
                    <div>
                        <span className="tab">&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;</span>
                        <span style={{ fontSize: '14px' }}>
                            + {item?.name}: <b>{item?.total}</b>
                        </span>
                        <span className="newline"></span>
                    </div>
                ))}
                <span className="tab">&#9;&#9;&#9;</span>
                <span className="newline"></span>
                <span className="tab">&#9;&#9;&#9;</span>
                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>
                    {`- Tiền thực thu: ${formatNumberMoney(dataReport?.generateOrder?.tongtien)} ₫`}
                </span>
                <span className="newline"></span>
            </div>
        </div>
    );
};

export default CopyContent;
